var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"image-grid"},_vm._l((_vm.imageList),function(image){return _c('div',{key:image.id,staticClass:"image-item"},[_c('img',{attrs:{"src":image.url},on:{"click":function($event){return _vm.choose(image.url)}}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }